import { Tag } from 'antd';
import styled from 'styled-components';

import { Table } from '@atom/table/table';
import { Title } from '@atom/typography/typography';

export const SubTitleWrapper = styled.div`
  display: flex;
  padding: 0 0 20px;
  justify-content: center;
`;

export const SubTitle = styled(Title).attrs({
  level: 3,
  weight: 400,
})`
  flex: 1;
`;

export const RoleTag = styled(Tag).attrs({
  color: 'geekblue',
})`
  text-transform: capitalize;
`;

export const TableConsumer = styled(Table)`
  & .ant-table-row {
    cursor: pointer;
  }
`;
